import React from "react";

const XmenIcon = () => {
	return (
		<svg viewBox="0 0 24 24">
			<path d="M12,0C5.3833008,0,0,5.3833008,0,12s5.3833008,12,12,12s12-5.3833008,12-12S18.6166992,0,12,0z   M8.4648438,12l-3.6005859,3.6000977C4.2973633,14.4819336,4,13.2495117,4,12s0.2973633-2.4819336,0.8642578-3.6000977L8.4648438,12  z M12,8.4648438L8.3999023,4.8642578c2.2363281-1.1337891,4.9638672-1.1337891,7.2001953,0L12,8.4648438z M12,15.5351563  l3.6000977,3.6005859c-2.2363281,1.1337891-4.9638672,1.1337891-7.2001953,0L12,15.5351563z M15.5351563,12l3.6005859-3.6000977  C19.7026367,9.5180664,20,10.7504883,20,12s-0.2973633,2.4819336-0.8642578,3.6000977L15.5351563,12z" fill="currentColor"/>
		</svg>
	);
};

export default XmenIcon;
